import { useEffect, useState } from "react";
import WellnessProgressTracker from "../../components/WellnessProgressTracker";
import { motion } from "framer-motion";
import ReactPlayer from "react-player/lazy";
import { Clock } from "lucide-react";
import { useBootstrap } from "@/features/bootstrap";
import { useAudioNavigation } from "@/hooks/useAudioNavigation";
import { useAudioPreference } from "../../hooks/useAudioPreference";

const AUDIO_DURATION_MS = 12000;
const SAFETY_NET_MS = 25000;
const PROGRESS_TICK_MS = AUDIO_DURATION_MS / 100;

const SeeAndHear = () => {
  const { data: user } = useBootstrap();
  const [playing] = useAudioPreference();
  const [progress, setProgress] = useState(0);

  const audio_url_prefix = (user?.voice ?? "english female").replace(" ", "_");
  const audioHandlers = useAudioNavigation({
    to: "/deepbreathe3",
    fallbackMs: AUDIO_DURATION_MS,
    safetyNetMs: SAFETY_NET_MS,
  });

  useEffect(() => {
    const progressTimer = setInterval(() => {
      setProgress((prevProgress) =>
        prevProgress >= 100 ? 100 : prevProgress + 1,
      );
    }, PROGRESS_TICK_MS);

    return () => {
      clearInterval(progressTimer);
    };
  }, []);

  return (
    <>
     <div className="sticky top-0 mt-10 sm:mt-0 z-10 shrink-0 bg-white sm:ml-[130px] px-0 sm:px-8 lg:px-32">
        <header className="px-4 py-4 text-center sm:px-6 sm:pb-4 sm:pt-12">
          <h1 className="mb-2 text-2xl font-bold md:text-3xl">What do I see and hear?</h1>
          <p className="mx-auto text-[15px] sm:text-base text-gray-600">Focus away from the screen and notice what's around you</p>
        </header>
        <WellnessProgressTracker />
      </div>
      <motion.div className="flex max-h-screen flex-1 flex-row bg-white">
        <div className="h-0 w-0 overflow-hidden opacity-0">
          <ReactPlayer
            playing={playing}
            url={"audio/" + audio_url_prefix + "/seeandhear.wav"}
            {...audioHandlers}
        />
        </div>
        <div className="flex w-full flex-col items-center bg-white sm:ml-[130px]">
          <div className="flex flex-col items-center lg:flex-row">
            <img
              className="h-[200px] w-[200px] md:h-[350px] md:w-[350px]"
              src="../images/Eyes.gif"
              alt=""
              loading="lazy"
            />
            <img
              className="h-[200px] w-[200px] md:h-[350px] md:w-[350px]"
              src="../images/Ears.gif"
              alt=""
              loading="lazy"
            />
          </div>
          <div className="mt-2 flex items-center justify-center gap-3" aria-label="Timer progress">
            {[0, 1, 2].map((i) => {
              const segmentStart = (i / 3) * 100;
              const segmentEnd = ((i + 1) / 3) * 100;
              const fillPercent = progress <= segmentStart ? 0 : progress >= segmentEnd ? 100 : ((progress - segmentStart) / (segmentEnd - segmentStart)) * 100;
              return (
                <div
                  key={i}
                  className="relative h-3.5 w-3.5 shrink-0 overflow-hidden rounded-full border-1 border-[#BBBBBB]"
                  aria-hidden
                >
                  <div
                    className="absolute inset-y-0 left-0 bg-black transition-[width] duration-150 ease-linear"
                    style={{ width: `${fillPercent}%` }}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default SeeAndHear;
